<template>
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="titArea">
            <span class="txtL pointC4">
              <em>{{ userInfo.userName }}</em>
              님이 지금까지 받은 혜택이에요.
            </span>
          </div>

          <div class="orderSum mybf">
            <ul class="infoList">
              <li>
                <span class="item">내가받은혜택</span>
                <span class="val">
                  <span class="money">
                    총
                    <em>{{ myBenefit.totalBenefitAmount | currency }}</em>
                    원
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </section>

        <section class="full hr mb0">
          <div class="sortArea filter mb0">
            <div class="lcont">
              <span class="txt">
                총
                <em v-if="myBenefit.benefits">{{ myBenefit.benefits.length }}</em>
                <em v-else>0</em>
                개
              </span>
            </div>
            <div class="rcont">
              <select class="btnTxt_sort sel" title="기간 선택" v-model="yearValue" @change="yearChange($event)">
                <option value="all" selected="selected">전체</option>
                <option v-for="option in yearSelectOptions" :value="option" :key="option">{{ option }}년</option>
              </select>
            </div>
          </div>
        </section>

        <section class="mt20 mb0" v-if="myBenefit.benefits && myBenefit.benefits.length > 0">
          <ul class="infoList benefit" v-for="(benefits, index) in myBenefit.benefits" :key="index">
            <li>
              <span class="tit">{{ benefits.receiptDate | dateFormatter('-') }}</span>
            </li>
            <li>
              <span class="item">혜택상품</span>
              <span class="val">
                {{ benefits.productName }}
                <span v-if="benefits.model != ''">({{ benefits.model }})</span>
              </span>
            </li>
            <li>
              <span class="item">주문번호</span>
              <span class="val">{{ benefits.orderId }}</span>
            </li>
            <li>
              <span class="item">혜택/쿠폰</span>
              <span class="val">
                {{ benefits.benefit }}
                <br />
                <span class="desc" v-if="benefits.startDate == benefits.endDate">
                  {{ benefits.startDate | dateFormatter('-') }}
                </span>
                <span class="desc" v-if="benefits.startDate != benefits.endDate">
                  {{ benefits.startDate | dateFormatter('-') }}~{{ benefits.endDate | dateFormatter('-') }}
                </span>
              </span>
            </li>
            <li>
              <span class="item">혜택내용</span>
              <span class="val">{{ benefits.productName }} {{ benefits.invoiceSeq }}회차 렌탈료 할인</span>
            </li>
            <li>
              <span class="item">혜택금액</span>
              <span class="val">{{ benefits.amounts | currency }}원</span>
            </li>
          </ul>
        </section>

        <!-- 조회결과가 없을 때 -->
        <section class="mt20 mb0" v-else>
          <div class="resultMsg txtOnly">
            <p class="copy">혜택 내역이 없습니다.</p>
          </div>
        </section>

        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import CommonBanner from '@/components/banner/CommonBanner';
//import * as customjs from '@/../../static/js/m.front.js';

export default {
  name: 'benefitsMyBenefits',
  components: {
    CommonBanner,
  },
  data: function() {
    return {
      headerTitle: '나만의혜택',
      userInfo: JwtService.getUserInfo(),
      myBenefit: {},
      yearSelectOptions: [],
      yearValue: 'all',
    };
  },
  mounted() {
    this.selectYearSelectOptions();
    this.selectMyBenefit();
  },
  methods: {
    selectYearSelectOptions() {
      const fullYear = new Date().getFullYear();

      for (let i = fullYear; i >= fullYear - 4; i--) {
        this.yearSelectOptions.push(i);
      }
    },
    yearChange(event) {
      this.yearValue = event.target.value;

      this.selectMyBenefit();
    },
    selectMyBenefit() {
      ApiService.service('GET', '/user/auth/mybenefit/' + this.yearValue, '')
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.myBenefit = data.result;
          } else {
            this.myBenefit = {};
            this.myBenefit.totalBenefitAmount = 0;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
};
</script>
